import t from"styled-components";import{theme as o}from"../../../../theme.js";const e=t.span`
  font-size: 12px;
  font-weight: 700;
  color: ${o.colors.gray[400]};
`;t.div`
  width: 400px;
  &.large {
    width: ${o.maxWidth};
    @media screen and (max-width: ${o.breakpoints.lg}) {
      width: 100%;
    }
  }
`;export{e as PromotedLabel};
